import 'styles/globals.css';
import 'utils/polyfills';
import type { AppProps, NextWebVitalsMetric } from 'next/app';
import Head from 'next/head';
import { useRouter } from 'next/router';
import type { FC } from 'react';

import { getCanonicalUrlWithAppPath } from 'navigation/urls';
import { GTMNoScript } from 'components/atoms/GTMNoScript';
import { initAnalytics } from 'utils/analytics/initAnalytics';
import { trackMetricsEvent } from 'utils/analytics/trackEvent';
import { CrimtanConsentScripts } from 'components/crimtan/CrimtanConsentScripts';

initAnalytics();

const OctopusApp: FC<AppProps> = ({ Component, pageProps }) => {
  const { asPath } = useRouter();

  return (
    <>
      <Head>
        <meta property="og:url" content={getCanonicalUrlWithAppPath(asPath)} />
      </Head>
      <noscript>
        <GTMNoScript />
      </noscript>
      <Component {...pageProps} />
      <CrimtanConsentScripts />
    </>
  );
};

export function reportWebVitals({
  id,
  name,
  label,
  value,
}: NextWebVitalsMetric) {
  trackMetricsEvent({
    name,
    category: label === 'web-vital' ? 'Web Vitals' : 'Next.js custom metric',
    label: id,
    value: Math.round(name === 'CLS' ? value * 1000 : value), // values must be integers
  });
}

export default OctopusApp;
